import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M6.5 8.5v-2.333A1.167 1.167 0 017.667 5h4.944l1.778 1.778h4.966a1.167 1.167 0 011.166 1.167v8.778a1.167 1.167 0 01-1.166 1.166H14.5v2.334a1.167 1.167 0 01-1.167 1.167H5.667A1.167 1.167 0 014.5 19.5v-9.333a1.167 1.167 0 011.167-1.167h2.333zm0 1.556H5.667v8.778h8.778v-1.556H6.5V10.056zM8 7.5v7.778h8.778V9.056h-4.166l-1.778-1.778H8z"
      ></path>
    </svg>
  )
}

export default Icon
